import { render, staticRenderFns } from "./ActivationBriefNetworksFaqRouterView.vue?vue&type=template&id=2121b30a&"
import script from "./ActivationBriefNetworksFaqRouterView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefNetworksFaqRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports